@if (config) {
  @if (config.type === 'text') {
    <button
      mat-button
      [tabIndex]="config.tabIndex || 0"
      [matTooltip]="config.tooltip"
      [ngClass]="[
        config.size || 'small',
        config.text ? '' : 'just-icon',
        config.loading && !config.disabled ? 'loading' : '',
        config.customClass ?? '',
      ]"
      [disabled]="config.disabled || disabled()"
      (click)="buttonClick.emit()"
      (keydown.enter)="buttonClick.emit()"
      [ariaLabel]="config.ariaLabel || config.text"
      [ariaDisabled]="config.disabled || disabled()"
      [ariaBusy]="config.loading"
      [attr.role]="'button'"
    >
      {{ config.text }}
      @if (config.frontIcon) {
        <mat-icon aria-hidden="true">{{ config.frontIcon }}</mat-icon>
      }
      @if (config.backIcon) {
        <mat-icon aria-hidden="true" iconPositionEnd>{{ config.backIcon }}</mat-icon>
      }
    </button>
  }
  @if (config.type === 'secondary') {
    <button
      mat-stroked-button
      [tabIndex]="config.tabIndex || 0"
      [matTooltip]="config.tooltip"
      [ngClass]="[
        config.size || 'small',
        config.text ? '' : 'just-icon',
        config.loading && !config.disabled ? 'loading' : '',
        config.customClass ?? '',
      ]"
      [disabled]="config.disabled || disabled()"
      (click)="buttonClick.emit()"
      (keydown.enter)="buttonClick.emit()"
      [ariaLabel]="config.ariaLabel || config.text"
      [ariaDisabled]="config.disabled || disabled()"
      [ariaBusy]="config.loading"
      [attr.role]="'button'"
    >
      {{ config.text }}
      @if (config.frontIcon) {
        <mat-icon>{{ config.frontIcon }}</mat-icon>
      }
      @if (config.backIcon) {
        <mat-icon iconPositionEnd>{{ config.backIcon }}</mat-icon>
      }
    </button>
  }
  @if (config.type === 'primary' || !config.type) {
    <button
      mat-flat-button
      [tabIndex]="config.tabIndex || 0"
      [matTooltip]="config.tooltip"
      [ngClass]="[
        config.size || 'small',
        config.text ? '' : 'just-icon',
        config.loading && !config.disabled ? 'loading' : '',
        config.customClass ?? '',
      ]"
      [disabled]="config.disabled || disabled()"
      (click)="buttonClick.emit()"
      (keydown.enter)="buttonClick.emit()"
      [ariaLabel]="config.ariaLabel || config.text"
      [ariaDisabled]="config.disabled || disabled()"
      [ariaBusy]="config.loading"
      [attr.role]="'button'"
    >
      {{ config.text }}
      @if (config.frontIcon) {
        <mat-icon>{{ config.frontIcon }}</mat-icon>
      }
      @if (config.backIcon) {
        <mat-icon iconPositionEnd>{{ config.backIcon }}</mat-icon>
      }
    </button>
  }
  @if (config.type === 'icon') {
    <button
      mat-icon-button
      [tabIndex]="config.tabIndex || 0"
      [matTooltip]="config.tooltip"
      [ngClass]="[
        config.size || 'small',
        config.text ? '' : 'just-icon',
        config.loading && !config.disabled ? 'loading' : '',
        config.customClass ?? '',
      ]"
      [disabled]="config.disabled || disabled()"
      (click)="buttonClick.emit()"
      (keydown.enter)="buttonClick.emit()"
      [ariaLabel]="config.ariaLabel || config.text"
      [ariaDisabled]="config.disabled || disabled()"
      [ariaBusy]="config.loading"
      [attr.role]="'button'"
    >
      <mat-icon>{{ config.frontIcon || config.backIcon }}</mat-icon>
    </button>
  }
}
